const NOTIFICATION_TYPE_SLIDE_OUT = 'Slide-out';
const NOTIFICATION_TYPE_POPUP = 'Popup';
export const POPUP_NO_TYPE = 'no_type';
export const POPUP_TYPE_TIP = 'tip';
export const POPUP_TYPE_VERGIST = 'vergist';

import { defineStore } from 'pinia';

export const useNotificationsStore = defineStore('notification', {
  state: () => ({
    type: NOTIFICATION_TYPE_POPUP,
    props: {
      // General
      titel: '',
      content: '',
      contentType: '',
      // Popup
      type: undefined,
      triggerAttentionBounce: false
    }
  }),
  getters: {
    showNotification: (state) => !!(state.props.titel || state.props.content),
    isSlideOut: (state) => state.type === NOTIFICATION_TYPE_SLIDE_OUT,
    xerModalPictogram(state) {
      if (!state.props.type) return undefined;

      const iconType = state.props.type.toLowerCase();
      switch (iconType) {
        case POPUP_TYPE_VERGIST:
          return 'warning';
        case POPUP_TYPE_TIP:
          return 'lamp';
        default:
          return '';
      }
    }
  },
  actions: {
    openPopUp(props) {
      this.open(NOTIFICATION_TYPE_POPUP, props);
    },
    openSlideOut(props) {
      this.open(NOTIFICATION_TYPE_SLIDE_OUT, props);
    },
    forceClose() {
      if (this.showNotification) {
        this.close();
      }
    },
    open(type, props) {
      this.type = type;
      this.props = { ...props };
    },
    close() {
      this.props = {
        ...this.props, // keep other props for app post close action (e.g. XerNavBar attentionBounce)
        titel: '',
        content: '',
        contentType: ''
      };
    }
  }
});
